export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const groupBy = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

export const groupAndSubgroupBy = (objectArray, groupProperty, subgroupProperty) => {
    return objectArray.reduce((accumulator, obj) => {
        const groupKey = obj[groupProperty];
        let group = accumulator[groupKey];
        if (!group) {
            group = {};
            accumulator[groupKey] = group;
        }

        const subgroupKey = obj[subgroupProperty];
        let subgroup = group[subgroupKey];
        if (!subgroup) {
            subgroup = [];
            group[subgroupKey] = subgroup;
        }

        subgroup.push(obj);
        return accumulator;
    }, {});
}

export const distinctBy = (objectArray, property) => {
    let result = [];
    let distinctVals = new Set(objectArray);
    for (const o of objectArray) {
        if (!distinctVals.has(o[property])) {
            distinctVals.add(o[property]);
            result.push(o);
        }
    }

    return result;
}

export const sortByProp = (objectArray, property) => {
    return objectArray.sort(function (a, b) {
        if (a[property] < b[property]) { return -1; }
        if (a[property] > b[property]) { return 1; }
        return 0;
    })
}

export const getMonthName = (monthNumber) => {
    return MONTHS[monthNumber - 1];
}

export const getMonthNumber = (monthName) => {
    return MONTHS.indexOf(monthName) + 1;
}

// Given a set of data with integer "year" and "month" properties, returns the individual months in the range as strings, filling in any gaps,
// Example: ["Feb-2015", "Feb-2015"..."Apr-2019"]
export const getMonthTickValues = (rawData) => {
    const groupedByYear = groupBy(rawData, "year");
    const yearRange = Object.keys(groupedByYear).sort();
    const firstYear = parseInt(yearRange[0]);
    const lastYear = parseInt(yearRange[yearRange.length - 1]);
    const firstMonthRange = Array.from(new Set(groupedByYear[`${firstYear}`].map(d => d.month)))
        .sort();
    const firstMonth = firstMonthRange[0];
    const lastMonthRange = Array.from(new Set(groupedByYear[`${lastYear}`].map(d => d.month)))
        .sort();
    const lastMonth = lastMonthRange[lastMonthRange.length - 1];
    let domain = [];
    for (let year = firstYear; year < lastYear + 1; year++) {
        for (let month = (year === firstYear ? firstMonth : 1); month < (year === lastYear ? lastMonth + 1 : 13); month++) {
            domain.push(`${getMonthName(month)}-${year}`);
        }
    }

    return domain;
}

export const getRatioAsPercentage = (numerator, denominator) => {
    return !denominator
        ? 0
        : Math.round((numerator / denominator) * 100);
}